import { render, staticRenderFns } from "./RewardIconNotEarned.vue?vue&type=template&id=36d7b1d8&"
import script from "./RewardIconNotEarned.vue?vue&type=script&lang=js&"
export * from "./RewardIconNotEarned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d7b1d8')) {
      api.createRecord('36d7b1d8', component.options)
    } else {
      api.reload('36d7b1d8', component.options)
    }
    module.hot.accept("./RewardIconNotEarned.vue?vue&type=template&id=36d7b1d8&", function () {
      api.rerender('36d7b1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardIconNotEarned.vue"
export default component.exports